
export class ProgramReportingNav {
  public static item = {
    title: 'program.tab.reporting',
    url: 'reporting',
    icon: '<img src="./assets/icons/line-icons/nav/grey/financials.svg" width="23px" height="23px">',
    testId: 'prog-nav-claims',
  };
}
